<template>
  <div>
    <b-container fluid class="tw-mb-5 tw-bg-gray-100 tw-border tw-border-blue-200" style="padding-bottom: 10px;">
        <b-row class="tw-mt-2">
          <b-col cols="auto" v-if="STUDY == 'kenya'">
              <b-form-select size="lg" v-model="studyPhase" :options="studyPhaseOptions"></b-form-select>
          </b-col>
          <b-col cols="auto">
              <b-form-select v-if="STUDY == 'kenya'" size="lg" v-model="dataPoints" :options="dataPointsOptions"></b-form-select>
          </b-col>
        </b-row>

      <b-row>
        <b-col md="12" lg="7" :xl="STUDY == 'kenya' ? 8 : 10" class="tw-overflow-x-scroll" ref="clusterEnrollmentChartContainer">
          <bar-chart
            v-if="loaded"
            :chartData="clusterEnrollment.chartdata"
            :options="clusterEnrollment.options"
            :styles="clusterEnrollment.myStyles"
          >
          </bar-chart>
        </b-col>
        <b-col md="12" lg="5" :xl="STUDY == 'kenya' ? 4 : 2">
          <b-container>
            <b-row>
              <b-col lg="12" :xl="STUDY == 'kenya' ? 6 : 12" class="tw-p-1">
                <b-card>
                  <b-card-text>
                    <span v-if="STUDY == 'kenya'">
                    <h6 class="tw-font-bolder tw-mb-0 text-center">
                      Core
                    </h6>
                    <p v-if="dataPoints == 'Enrolled'" class="text-secondary tw-text-xs text-center">
                      Total Enrolled
                    </p>
                    </span>
                    <span v-if="STUDY == 'mali'">
                      <h6 class="tw-font-bolder tw-mb-0 text-center">
                        Total Enrolled
                      </h6>
                    </span>

                    <p v-if="dataPoints == 'Consented'" class="text-secondary tw-text-xs text-center">
                      Total Consented
                    </p>
                    <p v-if="dataPoints == 'In-Progress'" class="text-secondary tw-text-xs text-center">
                      Total In-Progress
                    </p>
                    <h1 class="tw-text-2xl tw-font-bolder text-center tw-mb-0" v-if="STUDY == 'kenya'">
                      {{ totalCore }} / 812
                    </h1>
                    <h1 class="tw-text-2xl tw-font-bolder text-center tw-mb-0" v-else>
                      {{ totalCore }} / 1920
                    </h1>
                  </b-card-text>
                </b-card>
              </b-col>
              <b-col lg="12" xl="6" class="tw-p-1" v-if="STUDY == 'kenya'">
                <b-card>
                  <b-card-text>
                    <h6 class="tw-font-bolder tw-mb-0 text-center">
                      Buffer
                    </h6>
                    <p v-if="dataPoints == 'Enrolled'" class="text-secondary tw-text-xs text-center">
                      Total Enrolled
                    </p>
                    <p v-if="dataPoints == 'Consented'" class="text-secondary tw-text-xs text-center">
                      Total Consented
                    </p>
                    <p v-if="dataPoints == 'In-Progress'" class="text-secondary tw-text-xs text-center">
                      Total In-Progress
                    </p>
                    <h1 class="tw-text-2xl tw-font-bolder text-center tw-mb-0">
                      {{ totalBuffer }} / 1160
                    </h1>
                  </b-card-text>
                </b-card>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="12" :xl="STUDY == 'kenya' ? 6 : 12" class="tw-p-1">
                <b-card>
                  <b-card-text>
                    <span v-if="STUDY == 'kenya'">
                    <h6 class="tw-font-bolder tw-mb-0 text-center">
                      Core Clusters
                    </h6>
                    <p v-if="dataPoints == 'Enrolled'" class="text-secondary tw-text-xs text-center">
                      Enrollments Complete
                    </p>
                    </span>
                    <span v-else>
                      <h6 class="tw-font-bolder tw-mb-0 text-center">
                        Enrollments Complete
                      </h6>
                    </span>
                    <p v-if="dataPoints == 'Consented'" class="text-secondary tw-text-xs text-center">
                      Consented Complete
                    </p>
                    <span v-if="STUDY == 'kenya'">
                    <h1 v-if="dataPoints != 'In-Progress'" class="tw-text-3xl tw-font-bolder text-center tw-mb-0">
                      {{ clustersReachedCoreTarget }}/58
                    </h1>
                    <h1 v-else class="tw-text-3xl tw-font-bolder text-center tw-mb-0">
                      N/A
                    </h1>
                    </span>
                    <span v-else>
                    <h1 v-if="dataPoints != 'In-Progress'" class="tw-text-3xl tw-font-bolder text-center tw-mb-0">
                      {{ clustersReachedCoreTarget }}/60
                    </h1>
                    <h1 v-else class="tw-text-3xl tw-font-bolder text-center tw-mb-0">
                      N/A
                    </h1>
                    </span>
                  </b-card-text>
                </b-card>
              </b-col>
              <b-col lg="12" xl="6" class="tw-p-1" v-if="STUDY == 'kenya'">
                <b-card>
                  <b-card-text>
                    <h6 class="tw-font-bolder tw-mb-0 text-center">
                      Buffer Clusters
                    </h6>
                    <p v-if="dataPoints == 'Enrolled'" class="text-secondary tw-text-xs text-center">
                      Enrollments Complete
                    </p>
                    <p v-if="dataPoints == 'Consented'" class="text-secondary tw-text-xs text-center">
                      Consented Complete
                    </p>
                    <h1 v-if="dataPoints != 'In-Progress'" class="tw-text-3xl tw-font-bolder text-center tw-mb-0">
                      {{ clustersReachedBufferTarget }}/58
                    </h1>
                    <h1 v-else class="tw-text-3xl tw-font-bolder text-center tw-mb-0">
                      N/A
                    </h1>
                  </b-card-text>
                </b-card>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <div class="tw-mt-auto tw-flex tw-justify-end">
            <info-popover>
              <template v-slot:title>
                Cluster Enrollment
              </template>

              <p>
                For each cluster, show how many core/buffer subjects are
                enrolled, and which have crossed/met the targets.
              </p>
            </info-popover>
          </div>
        </b-col>
      </b-row>

      <b-row v-if="STUDY == 'kenya'">
        <b-col v-if="visible" cols="3">
          <b-button @click="visible = !visible">
            Hide Map
          </b-button>
          <br /><br />
           <b-form-group
            id="cluster-map-select-group"
            label="Zoom To Cluster"
            label-for="cluster-map-select"
          >
            <b-form-select id="cluster-map-select" :options="clusterSelectorOptions" v-model="selectedCluster" trim></b-form-select>
          </b-form-group>
        </b-col>
        <b-col v-if="!visible">
          <b-button @click="visible = !visible">
            Show Map
          </b-button>
        </b-col>
      </b-row>
       <b-row class="hidden-map" ref="map_row" >
              <v-map ref="myMap" :zoom="7" :center="initialLocation" :options="{scrollWheelZoom: false}" style="height: 700px; margin-top: 10px;">
                  <v-tilelayer url="https://{s}.tile.osm.org/{z}/{x}/{y}.png"></v-tilelayer>
                  <!-- <v-tilelayer url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"></v-tilelayer> -->

                  <!-- <v-marker :lat-lng="[0.5736182,34.5356511]"></v-marker> -->
                  <!-- <v-marker :lat-lng="[0.5736182,34.5356511]" :icon="icon"></v-marker> -->

                  <!-- <v-circle :lat-lng="[0.5736182,34.5356511]" :radius="30000"></v-circle> -->
                  <!-- <v-rectangle :bounds="bounds" :weight="1" :color="'#ff0000'"></v-rectangle> -->
                </v-map>
          </b-row>
    </b-container>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

// import {
//     mapState, mapGetters, mapActions
// } from 'vuex';


import * as _ from "lodash";

import { LMap, LTileLayer } from "vue2-leaflet";
import { Icon, Marker, LayerGroup, polygon, latLngBounds, featureGroup } from "leaflet";

import BarChart from "@/components/charts/BarChart.vue";
// import func from 'vue-editor-bridge';

export default {
  mixins: [],
  components: {
    BarChart,
    "v-map": LMap,
    "v-tilelayer": LTileLayer,
  },
  props: {},
  data() {
    return {
      loaded: false,
      studyPhase: 'Cohort 2',
      studyPhaseOptions: ['Baseline', 'Cohort 1', 'Cohort 2'],
      dataPoints: 'Consented',
      dataPointsOptions: ['Consented', 'Enrolled', 'In-Progress'],
      coreTarget: 14,
      bufferTarget: 20,
      criticalThreshold: 19,
      totalCore: 0,
      totalBuffer: 0,
      clustersReachedCoreTarget: 0,
      clustersReachedBufferTarget: 0,
      clusterSelectorOptions: [
        {value: null, text: 'Select cluster number...'}
      ],
      selectedCluster: null,
      clusterEnrollment: {
        chartdata: {
          datasets: [
            {
              label: "Core",
              backgroundColor: "red",
              data: [45, 23],
            },
            {
              label: "Buffer",
              backgroundColor: "green",
              data: [42, 20],
            },
          ],
          labels: [1, 2],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            position: "top",
            labels: {
              boxWidth: 18,
            },
          },
          title: {
            display: true,
            text: "Cluster Enrollment Progress",
          },
          animation: {
            animateScale: true,
            animateRotate: true,
          },
          scales: {
            xAxes: [
              {
                stacked: false,
                gridLines: {
                  display: true,
                },
                scaleLabel: {
                  display: true,
                  labelString: "Cluster",
                },
              },
            ],
            yAxes: [
              {
                stacked: false,
                gridLines: {
                  display: true,
                },
                scaleLabel: {
                  display: true,
                  labelString: "Enrollment Count",
                },
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
        },
        myStyles: {
          height: "25vh",
          width: "150vh",
          position: "relative",
        },
      },

      // -- Map -- //
      initialLocation: [0.5064000000000988,34.2367000000001],
      bounds: [[0.8536182, 34.0356511], [0.2936182, 35.0356511]],
      villages_layer: null,
      village_collection: [],
      visible: false,
      map_never_opened: true
    };
  },
  computed: {
    // ...mapState('sample', ['sample'])
  },
  watch: {
    selectedCluster: function() {
      let that = this;
      _.each(that.village_collection, function(village){
        if(parseInt(village.item.cluster_number) == that.selectedCluster){
          that.$refs.myMap.mapObject.fitBounds(village.polygon.getBounds());
          village.polygon.fire("click");
        }
      });
    },
    studyPhase: function() {
      this.get();
      this.getMap();
    },
    dataPoints: function(){
      this.get();
    },
    visible: function(val){
      if(val){
        this.$refs.map_row.style.display = 'block';
        this.$refs.myMap.mapObject.invalidateSize(true);

        // zoom into the village layer
        if(this.map_never_opened){
          this.$refs.myMap.mapObject.fitBounds(this.bounds);
          this.map_never_opened = false;
        }
      }
      else{
        this.$refs.map_row.style.display = 'none';
      }
        
    }
  },
  created: function() {

    // populate cluster selector options with 1-60
    for(var i = 1; i <= 60; i++){
      this.clusterSelectorOptions.push(i);
    }
  },
  mounted: function() {
    if(this.STUDY != 'kenya'){
      this.dataPoints = 'Enrolled';
      this.coreTarget = 32;
      this.studyPhase = 'Baseline';
    }
    else{

      this.getMap();
    }
    this.get();
  },
  methods: {
    getMap: function(){
      this.$nextTick(() => {
        this.$refs.myMap.mapObject.fitBounds(this.bounds);
      });
      let that = this;

      HTTP.get("/kenya/maps/get_cluster_villages").then(response => {
        let that = this;
        if(that.villages_layer != null){
          that.$refs.myMap.mapObject.removeLayer(that.villages_layer);
        }
        that.bounds = latLngBounds([]);
        var villages = [];
        _.each(response.data, function(item){
          let fillColor = '#ff0000';
          let borderColor = '#a33636';
          if(that.studyPhase in item.enrollment_progress){
            if(item.enrollment_progress[that.studyPhase].target_met == true){
              fillColor = '#00FF00';
              borderColor = '#32a852';
            }
              var village = polygon(item.polygon_normalized, {'item': item}).bindPopup('\
              <div style="text-align: center; font-size: 14px; margin-bottom: 10px;"><b>Cluster '+item.cluster_number+'</b></div>\
              \
              <div><b>Enrolled (Core):</b><span style="float: right;">'+item.enrollment_progress[that.studyPhase].core.enrolled+'</span></div>\
              <div style="margin-bottom: 7px;"><b>Enrolled (Buffer):</b><span style="float: right;">'+item.enrollment_progress[that.studyPhase].buffer.enrolled+'</span></div>\
              <div><b>Consented (Core):</b><span style="float: right;">'+item.enrollment_progress[that.studyPhase].core.consented+'</span></div>\
              <div style="margin-bottom: 7px;"><b>Consented (Buffer):</b><span style="float: right;">'+item.enrollment_progress[that.studyPhase].buffer.consented+'</span></div>\
              <div><b>In-Progress (Core):</b><span style="float: right;">'+item.enrollment_progress[that.studyPhase].core.in_progress+'</span></div>\
              <div><b>In-Progress (Buffer):</b><span style="float: right;">'+item.enrollment_progress[that.studyPhase].buffer.in_progress+'</span></div>').on(
                'click',
                that.village_clicked
              ).setStyle({fillColor: fillColor, color: borderColor, weight: 1});
              that.village_collection.push({
                item: item,
                polygon: village
              });
              villages.push(village);
              var layerBounds = village.getBounds();
              that.bounds.extend(layerBounds);
          }
          else{
              var village = polygon(item.polygon_normalized, {'item': item}).bindPopup('\
              <div style="text-align: center; font-size: 14px; margin-bottom: 10px;"><b>Cluster '+item.cluster_number+'</b></div>\
              \
              <div><b>Enrolled (Core):</b><span style="float: right;">0</span></div>\
              <div style="margin-bottom: 7px;"><b>Enrolled (Buffer):</b><span style="float: right;">0</span></div>\
              <div><b>Consented (Core):</b><span style="float: right;">0</span></div>\
              <div style="margin-bottom: 7px;"><b>Consented (Buffer):</b><span style="float: right;">0</span></div>\
              <div><b>In-Progress (Core):</b><span style="float: right;">0</span></div>\
              <div><b>In-Progress (Buffer):</b><span style="float: right;">0</span></div>').on(
                'click',
                that.village_clicked
              ).setStyle({fillColor: fillColor, color: borderColor, weight: 1});
              that.village_collection.push({
                item: item,
                polygon: village
              });
              villages.push(village);
              var layerBounds = village.getBounds();
              that.bounds.extend(layerBounds);
          }
          
        });
        that.villages_layer = new LayerGroup(villages);

        // add the village layer
        that.$refs.myMap.mapObject.addLayer(that.villages_layer);

        // zoom into the village layer
        that.$refs.myMap.mapObject.fitBounds(that.bounds);
      });
    },
    get: function() {
      let datasets = [];

      if(this.STUDY == 'kenya'){
        datasets = [
          {
            label: "Core",
            backgroundColor: "#37B1CA",
            data: [],
          },
          {
            label: "Buffer",
            backgroundColor: "#a3d2e0",
            data: [],
          },
          {
            type: "line",
            backgroundColor: "red",
            borderColor: "red",
            fill: false,
            pointRadius: 0,
            borderWidth: 1,
            label: "Core Target",
            data: [],
          },
          {
            type: "line",
            backgroundColor: "orange",
            borderColor: "orange",
            fill: false,
            pointRadius: 0,
            borderWidth: 1,
            label: "Buffer Target",
            data: [],
          },
        ];
      }
      if(this.STUDY == 'mali'){
        datasets = [
          {
            label: "Cluster Enrollment",
            backgroundColor: "#37B1CA",
            data: [],
          },
          {
            type: "line",
            backgroundColor: "orange",
            borderColor: "orange",
            fill: false,
            pointRadius: 0,
            borderWidth: 1,
            label: "Enrollment Target",
            data: [],
          },
          {
            type: "line",
            backgroundColor: "red",
            borderColor: "red",
            fill: false,
            pointRadius: 0,
            borderWidth: 1,
            label: "Critical Threshold",
            data: [],
          }
        ];
      }
      

      let labels = [];
      let core = {};
      let buffer = {};

      const that = this;
      HTTP.get("/kenya/metrics/cluster-enrollment", {params: {study_phase: that.studyPhase, data_points: that.dataPoints}})
        .then((response) => {
          that.totalCore = 0;
          that.totalBuffer = 0;
          that.clustersReachedCoreTarget = 0;
          that.clustersReachedBufferTarget = 0;
          _.each(response.data, function(item) {
            if (item.core_or_buffer === "core") {
              core[item.cluster_id] = item;
            } else {
              buffer[item.cluster_id] = item;
            }
          });

          let property_to_pull = 'current_enrollment_count';
          if(that.dataPoints == 'Consented'){
            property_to_pull = 'current_consented_count';
          }
          if(that.dataPoints == 'In-Progress'){
            property_to_pull = 'current_in_progress_count';
          }

          for (let x = 0; x < 60; x++) {
            let idx_str = String(x + 1);
            if (idx_str in core) {
              datasets[0].data.push(core[idx_str][property_to_pull]);
              that.totalCore += core[idx_str][property_to_pull];

              if (core[idx_str][property_to_pull] >= that.coreTarget) {
                that.clustersReachedCoreTarget += 1;
              }
            } else {
              datasets[0].data.push(0);
            }
            if(this.STUDY == 'kenya'){
              if (idx_str in buffer) {
                datasets[1].data.push(buffer[idx_str][property_to_pull]);
                that.totalBuffer += buffer[idx_str][property_to_pull];

                if (
                  buffer[idx_str][property_to_pull] >= that.bufferTarget
                ) {
                  that.clustersReachedBufferTarget += 1;
                }
              } else {
                datasets[1].data.push(0);
              }
            }
            labels.push(x + 1);
            if(this.STUDY == 'kenya'){
              datasets[2].data.push(that.coreTarget);
              datasets[3].data.push(that.bufferTarget);
            }
            if(this.STUDY == 'mali'){
              datasets[1].data.push(that.coreTarget);
              datasets[2].data.push(that.criticalThreshold);
            }
          }

            that.clusterEnrollment.chartdata = {
                datasets: datasets,
                labels: labels
            };

          that.loaded = true;

          setTimeout(function() {
            that.$refs['clusterEnrollmentChartContainer'].scrollLeft = that.$refs['clusterEnrollmentChartContainer'].scrollWidth / 3.5;
          }, 500);
        })
        .catch((error) => {
          HandleErrors.HandleErrors(error);
        });
    },
    find: function() {},
    create: function() {},
    patch: function() {},
    update: function() {},
    delete: function() {},
  },
};
</script>

<style>
nav.card-header {
  border-bottom: none;
  padding: 0.5rem 0 0 0;
}
ul.nav.nav-tabs {
  padding: 0 0.5rem;
}
ul.nav.nav-tabs li.nav-item {
  font-size: 0.7rem;
}
ul.nav.nav-tabs a.nav-link {
  padding: 0.35rem 0.5rem;
}

.leaflet-popup{
  width: 200px;
}

.hidden-map{
  display: none;
}

/* #bar-chart {
  height: 240px !important;
} */
</style>
